import { http, HttpResponse } from 'msw';
import endpoints from '@/api/endpoints';
import { IdempotencyOperationType } from '@/interfaces/idempotency';

const API_BASE_URL = endpoints.baseURL;

const EXPIRY_DURATION_MS = 30 * 60 * 1000; // 30 minutes

export const createIdempotencyKeyHandler = http.post<object, any, any>(
  `${API_BASE_URL}${endpoints.createIdempotencyKey}`,
  async ({ request }) => {
    const body = await request.json();
    const { operationType } = body;

    const validTypes = Object.values(IdempotencyOperationType) as string[];
    if (!operationType || !validTypes.includes(operationType)) {
      return HttpResponse.json({ code: 'invalid_operation_type', message: { en: 'Invalid or missing operationType' } }, { status: 400 });
    }

    return HttpResponse.json({
      key: `mock-idempotency-key-${operationType}-${Date.now()}`,
      operationType,
      expiresAt: new Date(Date.now() + EXPIRY_DURATION_MS).toISOString(),
    });
  }
);

export const idempotencyHandlers = [createIdempotencyKeyHandler];
